if (!HTMLFormElement.prototype.reportValidity) {
  HTMLFormElement.prototype.reportValidity = function() {
    if (this.checkValidity()) return true
    var btn = document.createElement('button')
    this.appendChild(btn)
    btn.click()
    this.removeChild(btn)
    return false
  }
}

/* polyfill reportValidity for HTML elements for user inputs */
function inputReportValidity(this: HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement) {
  if (this.checkValidity()) return true
  var form = this.form
  var tmpForm
  if (!form) {
    tmpForm = document.createElement('form')
    form = tmpForm
    tmpForm.style.display = 'inline'
    this.before(tmpForm)
    tmpForm.append(this)
  }
  var siblings = Array.from(form.elements).filter((input: any) => {
    return input !== this && !!input.checkValidity && !input.disabled
  })
  siblings.forEach(function(input: any) {
    input.disabled = true
  })
  form.reportValidity()
  siblings.forEach(function(input: any) {
    input.disabled = false
  })
  if (tmpForm) {
    tmpForm.before(this)
    tmpForm.remove()
  }
  this.focus()
  if ('selectionStart' in this) {
    this.selectionStart = 0
  }
  return false
}

if (!HTMLInputElement.prototype.reportValidity) {
  HTMLInputElement.prototype.reportValidity = inputReportValidity
}
if (!HTMLSelectElement.prototype.reportValidity) {
  HTMLSelectElement.prototype.reportValidity = inputReportValidity
}
if (!HTMLTextAreaElement.prototype.reportValidity) {
  HTMLTextAreaElement.prototype.reportValidity = inputReportValidity
}
